import { render, staticRenderFns } from "./PartnerServiceBind.vue?vue&type=template&id=012b33a6"
import script from "./PartnerServiceBind.vue?vue&type=script&lang=js"
export * from "./PartnerServiceBind.vue?vue&type=script&lang=js"
import style0 from "./PartnerServiceBind.vue?vue&type=style&index=0&id=012b33a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports